import TaskPanel from '../TaskPanel'
import {connect} from '../../../redux/utils'
import {
    canModifyAnyManager,
    canModifyAnyUser,
    canMoveTask,
    canReopenProject,
    getAssignedManagers,
    getAssignedUsers,
    getAuditActions,
    getBillingType,
    getCommentsCount,
    getCustomerName,
    getCustomerFromTask,
    getEstimatedTime,
    getLastAuditActions,
    getLastTaskPanelTabKey,
    getOpenTaskId,
    getOpenTaskNextId,
    getProjectName,
    getReadOnlyFields,
    getReportedTimeComments,
    getSortingSettings,
    getSpentTime,
    getTaskCustomFieldsValues,
    getTaskDeadline,
    getTaskDescription,
    getTaskDetails,
    getTaskExecutorsSummary,
    getTaskName,
    getTaskNewComment,
    getTaskPanelErrors,
    getTaskPanelTabKey,
    getTaskStatusId,
    isAllAuditHistoryLoaded,
    isAllTimeCommentsLoaded,
    isDeadlineUpdating,
    isDescriptionUpdating,
    isEditTaskPanelEditable,
    isEstimateUpdating,
    isMoveToDialogLoading,
    isNameUpdating,
    isSendingComment,
    isShowNewCommentInput,
    isStatusUpdating,
    isTaskCompleted,
    isTaskDeletedSuccessfully,
    isTaskDeletedUnsuccessfully,
    isTaskManageable,
    isTimeAndCommentsLoading,
    isTypeOfWorkUpdating,
} from './selectors'
import {
    copyTask,
    deleteAssignedManager,
    deleteAssignedUser,
    deleteTask,
    loadTaskAuditHistory,
    loadTimeComments,
    moveTask,
    openLastTaskPanelTab,
    reloadComments,
    resetDeletionStatus,
    saveComment,
    saveEditingComment,
    saveSortingSettings,
    setLastTaskPanelTab,
    setTaskPanelTab,
    toggleNewCommentInput,
    updateAssignedManagers,
    updateAssignedUsers,
    updateDeadline,
    updateDescription,
    updateEstimate,
    updateName,
    updateNewCommentText,
    updateStatus,
    updateTypeOfWork,
    updateCustomField,
} from './actions'
import {bindActionCreators} from 'redux'
import {
    canAccessSomeTeamAssignment, canEditHierarchy, canGenerateMoneyReports, canManageAccountsAndPermissions, getLoggedInUser,
    hasManageScopeRights
} from '../../../loggedInUser/selectors'
import {
    isBRAEnabled,
    isBTYEnabled,
    isCPTBUDEnabled,
    isESTEnabled,
    isTTAEnabled,
    isTWSEnabled,
    isTZGEnabled,
    isUGREnabled,
    isURAEnabled,
    isWASEnabled
} from '../../../features/selectors'
import {getTimeZoneGroups, getUserGroups} from '../../../entities/selectors'
import {
    canViewerEditTaskStatus,
    getCustomerIdsWhereCanManageLeastOneProject,
    getEditableCustomerIds,
    getEditableProjectIds,
    getEditableProjectIdsWithExcludeSelf,
} from '../../../taskManagement/common/selectors'
import {toast} from '../../../toasts/actions'
import {getFirstCompletedWorkflowStatus} from '../../../workflowStatus/selectors'
import {getSortedTypeOfWorkList} from '../../../typesOfWork/selectors'
import {selectTaskCustomFields} from '../../../customFields/selectors'

export default connect(
    state => ({
        loggedInUser: getLoggedInUser(state),
        sendingComment: isSendingComment(state),
        showNewCommentInput: isShowNewCommentInput(state),
        newCommentText: getTaskNewComment(state),

        canEdit: isEditTaskPanelEditable(state),
        canEditHierarchy: canEditHierarchy(state),
        openTaskId: getOpenTaskId(state),
        openTaskNextId: getOpenTaskNextId(state),
        name: getTaskName(state),
        completed: isTaskCompleted(state),
        workflowStatusId: getTaskStatusId(state),
        deadline: getTaskDeadline(state),
        typeOfWork: getBillingType(state),
        typesOfWork: getSortedTypeOfWorkList(state),
        estimatedTime: getEstimatedTime(state),
        spentTime: getSpentTime(state),
        description: getTaskDescription(state),
        commentsCount: getCommentsCount(state),

        projectName: getProjectName(state),
        customerName: getCustomerName(state),
        customer: getCustomerFromTask(state),

        nameUpdating: isNameUpdating(state),
        deadlineUpdating: isDeadlineUpdating(state),
        typeOfWorkUpdating: isTypeOfWorkUpdating(state),
        estimateUpdating: isEstimateUpdating(state),
        descriptionUpdating: isDescriptionUpdating(state),
        statusUpdating: isStatusUpdating(state),
        moveToDialogLoading: isMoveToDialogLoading(state),

        errors: getTaskPanelErrors(state),

        isBTYEnabled: isBTYEnabled(state),
        isURAEnabled: isURAEnabled(state),
        isBRAEnabled: isBRAEnabled(state),
        isTWSEnabled: isTWSEnabled(state),
        isESTEnabled: isESTEnabled(state),
        isWASEnabled: isWASEnabled(state),
        isTTAEnabled: isTTAEnabled(state),
        isCPTBUDEnabled: isCPTBUDEnabled(state),

        assignedUsers: getAssignedUsers(state),
        assignedManagers: getAssignedManagers(state),
        userGroupsEnabled: isUGREnabled(state),
        timeZoneGroupsEnabled: isTZGEnabled(state),
        userGroups: getUserGroups(state),
        timeZoneGroups: getTimeZoneGroups(state),
        canModifyAnyUser: canModifyAnyUser(state),
        canModifyAnyManager: canModifyAnyManager(state),
        canEditTaskStatus: canViewerEditTaskStatus(state),
        canGenerateMoneyReports: canGenerateMoneyReports(state),

        taskDetails: getTaskDetails(state),
        taskDeletedSuccessfully: isTaskDeletedSuccessfully(state),
        taskDeletedUnsuccessfully: isTaskDeletedUnsuccessfully(state),

        copyMoveSelectorsCustomerIds: getCustomerIdsWhereCanManageLeastOneProject(state),
        copyMoveSelectorsProjectIds: getEditableProjectIdsWithExcludeSelf(state),
        editableCustomersIds: getEditableCustomerIds(state),
        editableProjectsIds: getEditableProjectIds(state),

        auditActions: getAuditActions(state),
        lastAuditActions: getLastAuditActions(state),
        allAuditHistoryLoaded: isAllAuditHistoryLoaded(state),

        canReopenProject: canReopenProject(state),
        canMoveTask: canMoveTask(state),
        isTaskAssigned: isTaskManageable(state),
        canManageAccountsAndPermissions: canManageAccountsAndPermissions(state),
        hasManageScopeRights: hasManageScopeRights(state),
        executorsSummary: getTaskExecutorsSummary(state),
        reportedTimeComments: getReportedTimeComments(state),
        allTimeCommentsLoaded: isAllTimeCommentsLoaded(state),
        timeAndCommentsLoading: isTimeAndCommentsLoading(state),
        sortingSettings: getSortingSettings(state),

        currentTabKey: getTaskPanelTabKey(state),
        lastSelectedTabKey: getLastTaskPanelTabKey(state),

        defaultCompletedStatus: getFirstCompletedWorkflowStatus(state),

        hasSomeTeamAssignment: canAccessSomeTeamAssignment(state),

        customFields: selectTaskCustomFields(state),
        customFieldsValues: getTaskCustomFieldsValues(state),
        readonlyFields: getReadOnlyFields(state),
    }),
    dispatch => ({
        saveComment: bindActionCreators(saveComment, dispatch),
        saveEditingComment: bindActionCreators(saveEditingComment, dispatch),
        toggleNewCommentInput: bindActionCreators(toggleNewCommentInput, dispatch),
        updateNewCommentText: bindActionCreators(updateNewCommentText, dispatch),
        reloadComments: bindActionCreators(reloadComments, dispatch),
        deleteAssignedUser: bindActionCreators(deleteAssignedUser, dispatch),
        updateAssignedUsers: bindActionCreators(updateAssignedUsers, dispatch),
        deleteAssignedManager: bindActionCreators(deleteAssignedManager, dispatch),
        updateAssignedManagers: bindActionCreators(updateAssignedManagers, dispatch),
        deleteTask: bindActionCreators(deleteTask, dispatch),
        resetDeletionStatus: bindActionCreators(resetDeletionStatus, dispatch),
        moveTask: bindActionCreators(moveTask, dispatch),
        copyTask: bindActionCreators(copyTask, dispatch),
        loadTaskAuditHistory: bindActionCreators(loadTaskAuditHistory, dispatch),
        setTaskPanelTab: bindActionCreators(setTaskPanelTab, dispatch),
        setLastTaskPanelTab: bindActionCreators(setLastTaskPanelTab, dispatch),
        openLastTaskPanelTab: bindActionCreators(openLastTaskPanelTab, dispatch),
        loadTimeComments: bindActionCreators(loadTimeComments, dispatch),
        saveSortingSettings: bindActionCreators(saveSortingSettings, dispatch),
        toast: bindActionCreators(toast, dispatch),
        ...bindActionCreators({
            updateStatus,
            updateName,
            updateDeadline,
            updateTypeOfWork,
            updateEstimate,
            updateDescription,
            updateCustomField,
        }, dispatch),
    })
)(TaskPanel)



// WEBPACK FOOTER //
// ./web/js/panels/task/editPanel/EditTaskPanel.js